import ConnectToRoomForm from "../components/forms/ConnectToRoomForm"

const Home = () =>{
    return(
        <div className="home">    
            <ConnectToRoomForm/>
        </div>
    )
}

export default Home